/**
 * Which of the design's three badges a quote line earns.
 *
 * This is a CLIENT INFERENCE and a temporary one. The backend is better placed
 * to make the `ask_contractor` call than the client is: an unitemised lump sum
 * («Электрика, материал» — 48 000 сом) and a line the OCR simply read badly
 * both land on `confidence: "low"` today, and only one of them is something the
 * user should take back to their contractor. Backend capability C2 adds an
 * explicit `verdict`, and this function prefers it the moment it appears — so
 * that capability can land without a coordinated frontend release.
 *
 * Matches beat low confidence deliberately: if we found real sellers with real
 * prices for this line, we can price it, whatever our confidence in the OCR.
 */
import type { MaterialConfidence, SellerMatch } from "@/lib/garden-api";

export type LineVerdict = "stock" | "advice" | "ask_contractor";

const KNOWN: readonly LineVerdict[] = ["stock", "advice", "ask_contractor"];

export interface VerdictInput {
  matches: readonly SellerMatch[];
  confidence: MaterialConfidence;
  /** Backend capability C2. Absent today. */
  verdict?: LineVerdict | null;
}

export function lineVerdict(material: VerdictInput): LineVerdict {
  const stated = material.verdict;
  if (stated != null && KNOWN.includes(stated)) return stated;
  if (material.matches.length > 0) return "stock";
  return material.confidence === "low" ? "ask_contractor" : "advice";
}
